
import ArticleCard from '~/components/shared/ArticleCard'
export default {
  name: 'CategorizedBlogPostsComponent',
  components: { ArticleCard },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    categoryName() {
      return this.psgUnescapeHtml(this.category.name)
    },
  },
}
